export default __webpack_public_path__ + "static/media/cooling-tower.dc608a7e.png";